import { getAxiosInstance } from "../../../../api";

export const getPreviousPrintRecords = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/printing-report/print-records`, body);
    return res;
  } catch (error) {
    return error.response?.data;
  }
};
